import { Avatar } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';
import { useMemo } from 'react';

import { categories } from '@features/Cashback/Calculator/constants/categories';
import { RetailPartner } from '@generated/gql/graphql';

import './styles.scss';

const categoryColor = (category: string): string => {
  const defaultColor = 'pig';
  const categoryMatch = categories.find((cat) => cat.name === category);
  if (categoryMatch) return categoryMatch.color ?? defaultColor;
  return defaultColor;
};

const BrandLogo = ({
  brand,
  className = '',
}: {
  brand: RetailPartner;
  className?: string;
}) => {
  const color = useMemo(() => categoryColor(brand.category), [brand.category]);
  if (!brand.logoUrl) {
    return (
      <Avatar
        className={clsx('brand__Logo', `brand__Logo--${color}`, className)}
        name={brand.name.replace('&', '')}
        src={brand.logoUrl}
      />
    );
  }

  return (
    <img
      src={brand.logoUrl}
      alt=""
      className={clsx('brand__Logo', className)}
    />
  );
};

export { BrandLogo };
